import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Verified from "./images/checked.svg";
import { TRADE_IN_GA_EVENTS } from "./tracking";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";

const CdpValuationCard = ({tradeInData, showEdit, onEditClick}) => {
    const {vehicleMetaData} = tradeInData || {};

    useEffect(() => {
        trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.viewed, {
            ...TRADE_IN_GA_EVENTS.viewed
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div styleName={"styles.outer"}>
            {showEdit && <p styleName={"styles.edit"} onClick={onEditClick}>Edit</p>}
            <img src={Verified} alt="Valuation verified image" />
            <p className="headingText" styleName={"styles.heading"}>Your {(vehicleMetaData || {}).year} {(vehicleMetaData || {}).make} {(vehicleMetaData || {}).model} is <br /> eligible for trade-in value of</p>
            <p className="tradeInFlow" styleName={"styles.amount"}>{tradeInData.offeredPrice ? "" : "upto"} {makePriceLabelRound(tradeInData.offeredPrice || tradeInData.dsOfferedPrice || 0)}.</p>
        </div>
    );
};

CdpValuationCard.propTypes = {
    tradeInData: PropTypes.object,
    onEditClick: PropTypes.func,
    gaId: PropTypes.string,
    showEdit: PropTypes.bool
};

CdpValuationCard.defaultProps = {
    showEdit: true
};

export default CdpValuationCard;
